import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

export const useChangeCapabilityStatus = (options = {}) => {
  const res = useMutation(
    (dto) =>
      http.put(HTTP_ENDPOINTS.affirm.updateCapabilityStatus(dto.clinicId), {
        is_affirm_enabled: dto.isAffirmEnabled,
      }),
    { ...options },
  );
  return res;
};
